<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div
      v-for="(item, index) in getInformation"
      :key="index"
      :class="getClassNameItem"
    >
      <span class="matrix_informationLabel"> {{ $t(item.label) + ": " }} </span>
      <span class="matrix_informationValue">{{ item.value }}</span>
    </div>
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useChangeOptionsStore, ["getInformation"]),
    name: () => {
      return "Information";
    }
  }
};
</script>
